import { isTimePeriod, TimePeriod } from '../../common'

/** returns true if array has more than zero time perions and each time period is in order, otherwise false */
export const isAscTimePeriodArray = (x: any): x is TimePeriod[] => {
  let isTPArr = false
  if (!!x && x instanceof Array) {
    const arr = x as TimePeriod[]
    if (arr.length > 0 && arr.every(isTimePeriod)) {
      isTPArr = arr.reduce((a, c, i, arr) => {
        if (i > 0) {
          const last = arr[i - 1]
          a = a && last.toDateMs < c.fromDateMs
        }
        return a
      }, true as boolean)
    }
  }
  return isTPArr
}
